export const SET_LOADING = 'AuditMissionDashboard/SET_LOADING'
export const SET_AUDITS_STATISTICS =
  'AuditMissionDashboard/SET_AUDITS_STATISTICS'
